import { useState } from "react";
import emailjs from "emailjs-com";
import { saveOrder } from "../api/api";

const useSaveOrder = () => {
    const [isOrdered, setIsOrdered] = useState(false);

    const submitOrder = async (formData, orderItems, cityFilter, clearCart = null) => {
        try {
            const orderData = {
                firstName: formData.firstName,
                lastName: formData.lastName,
                phone: formData.phone,
                address: formData.address,
                city: cityFilter,
                note: formData.note || "",
                orderItems: orderItems.map(item => ({
                    id: item.id,
                    name: item.productname,
                    quantity: item.quantity,
                    option: item.option || "",
                    price: parseFloat(item.discount_price.replace(/[^\d.-]/g, "")) * item.quantity
                })),
                officeCode: formData.officeCode || '-1',
                finalPrice: formData.finalPrice || 0
            };

            await saveOrder(orderData);

            setIsOrdered(true);
            setTimeout(() => setIsOrdered(false), 5000);

            const orderDetails = orderItems
                .map(item => `Продукт: ${item.productname}, Количество: ${item.quantity}` + (item.option ? `, Опция: ${item.option}` : ""))
                .join("\n");

            formData.city = cityFilter;

            const emailData = { ...formData, order: orderDetails };

            emailjs.send("service_b06m24g", "template_mk02aun", emailData, "PLenflNoe6IDfFa9G")
                .then(() => {
                    setIsOrdered(true);
                    setTimeout(() => setIsOrdered(false), 5000);
                    if (clearCart) clearCart();
                })
                .catch((err) => {
                    alert("Грешка при изпращането на поръчката.");
                });

            formData.firstName = "";
            formData.lastName = "";
            formData.phone = "";
            formData.address = "";
            formData.city = "";
            formData.note = "";

            return true;
        } catch (error) {
            // Display only the error message
            alert(error.message);
    
            setIsOrdered(false);
            return false; 
        }
    };

    return { isOrdered, submitOrder };
};

export default useSaveOrder;
